import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { UnitFilters, UnitSlice } from "./unitsTypes.ts";

const initialState: UnitSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const unitsSlice = createSlice({
  name: "units",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<UnitSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<UnitSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof UnitFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<UnitSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  unitsSlice.actions;

export const selectPage = (state: RootState) => state.units.page;
export const selectRowsPerPage = (state: RootState) => state.units.rowsPerPage;
export const selectFilter = (state: RootState) => state.units.filter;
export const selectSort = (state: RootState) => state.units.sort;

export default unitsSlice.reducer;
